import { TDeviceType } from '@cian/ui-kit';

import { getPhoneStyles } from './phone';
import { getTabletDesktopStyles } from './tablet-desktop/getTabletDesktopStyles';

export function getDeviceStyles(deviceType: TDeviceType) {
  if (deviceType === 'phone') {
    return getPhoneStyles();
  }

  return getTabletDesktopStyles();
}
